// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1e22d85f","455":"e786190e"}[chunkId] + ".chunk.js";
};